$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();		
		if (!$(this).parent('.dropdown').hasClass('open')) {
			$('.dropdown').removeClass('open');
			$(this).parent('.dropdown').toggleClass('open');
		} else {
			$('.dropdown').removeClass('open');
		}
	});

	// -- Close dropdown on click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.dropdown');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.dropdown').removeClass('open');
	  }
	});

	// -- Close dropdown on mouseleave --
	var closeDropdownMenu; // global
	$('.header__mainMenu').on('mouseleave', '.dropdown-menu', function(){
		closeDropdownMenu = setTimeout(function(){
			$('.dropdown').removeClass('open');
		},5000);
	});

	// -- Clear timeout to prevent close dropdown on mouseenter --
	$('.header__mainMenu').on('mouseenter', '.dropdown-menu', function(){
		clearTimeout(closeDropdownMenu);
	});

});


// -- hide header on scroll down --
// (https://codingreflections.com/hide-header-on-scroll-down)
(function(){

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var body = document.getElementById('body');
  var header = document.getElementById('header');
  var hamburger = document.getElementById('hamburger');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      // -- scrolled up --
      direction = 2;
      // -- close dropdown --
      if (!$('.dropdown.level--1').hasClass('open')) {
  			$('.dropdown').removeClass('open');
      }
    }
    else if (curScroll < prevScroll) { 
      // -- scrolled down --
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > header.offsetHeight) { 
      if (!$('.dropdown.level--1').hasClass('open')) {    	
    		// -- close mobile menu --
	      body.classList.remove('mainMenu--open');
	      hamburger.classList.remove('is-active');
	      // -- hide menu --
	      header.classList.add('hide');
      }
      prevDirection = direction;
    } else if (direction === 1) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);

})();